import { UpdatePatientInput } from "healthex-common/patient.dtos";
import { getObservableT } from "../Infra/i18next";
import { SetupCompletionView } from "./AccountSetupCompletionView";
import { PatientConsentBaseViewModel } from "./PatientConsentBaseViewModel";
const t = getObservableT("patients");
export class PatientConsentSetupCompletionViewModel extends PatientConsentBaseViewModel {
    constructor(container) {
        super(container);
        this.patientConsentUIManager = container.patientConsentUIManager;
        this.accountSetupCompletionManager = container.accountSetupCompletionManager;
        this.socialLoginAuthManager = container.socialLoginAuthManager;
        this.verifyOTPManager = container.verifyOTPManager;
        this.persistence = container.persistence;
        this.bannerUIManager = container.bannerUIManager;
        this.accountSetupCompletionManager.prepopulate(this.patientConsentUIManager.consentingPatientInfo);
    }
    get formModel() {
        return this.accountSetupCompletionManager.formModel;
    }
    get hasAgeValidationError() {
        return this.accountSetupCompletionManager.hasAgeValidationError;
    }
    get viewToDisplay() {
        return this.accountSetupCompletionManager.shouldShowPhoneOnlyScreen ? SetupCompletionView.PHONE_ONLY : SetupCompletionView.FULL_FORM;
    }
    get isPhoneVerified() {
        return this.accountSetupCompletionManager.isPhoneVerified;
    }
    async continue() {
        var _a, _b, _c;
        if (!this.accountSetupCompletionManager.validateInput())
            return;
        const pendingVerificationKey = (_b = (_a = this.socialLoginAuthManager.pendingSocialLoginData) === null || _a === void 0 ? void 0 : _a.verificationKey) !== null && _b !== void 0 ? _b : (_c = this.persistence.getConsentDeferredVerificationStash()) === null || _c === void 0 ? void 0 : _c.verificationKey;
        const { input } = this.accountSetupCompletionManager;
        if (pendingVerificationKey && this.isPhoneVerified) {
            console.warn(`Phone already verified, skipping OTP verification`);
        }
        if (this.isPhoneVerified) {
            const ok = await this.patientConsentUIManager.updatePatient(new UpdatePatientInput({
                firstName: input.firstName,
                lastName: input.lastName,
                dateOfBirth: input.birthday,
                phone: input.mobilePhone || undefined,
            }));
            if (!ok) {
                this.bannerUIManager.displayBanner({
                    type: "ERROR",
                    text: t("Something went wrong. Please try again."),
                    durationInMS: 6000,
                });
                return;
            }
            await this.authManager.refreshTokenInfo();
            const nextPage = this.patientConsentUIManager.getNextPageRoute();
            if (nextPage) {
                this.patientConsentUIManager.goToPage(nextPage);
            }
            else {
                console.error("No next page found after patient update from setup completion");
            }
            return;
        }
        if (pendingVerificationKey) {
            this.accountSetupCompletionManager.trackDemographicsUpdatedIfFirstTime();
            this.verifyOTPManager.pendingVerificationKey = pendingVerificationKey;
            this.verifyOTPManager.pendingVerificationPhone = input.mobilePhone;
            const nextPage = this.patientConsentUIManager.getNextPageRoute();
            if (nextPage) {
                this.patientConsentUIManager.goToPage(nextPage);
                await this.verifyOTPManager.sendVerificationCode(true);
            }
            else {
                console.error("No next page found while going to next page");
            }
            return;
        }
        console.log(`No verification key`);
        const nextPage = this.patientConsentUIManager.getNextPageRoute();
        if (nextPage) {
            this.patientConsentUIManager.goToPage(nextPage);
        }
        else {
            console.error("No next page to go to");
        }
    }
}
